var TEMPLATE_URL = require('./credit.card.update.html');

angular.module('ikeweb.user').directive('updateCard',
    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            controller: 'CreditCardUpdateController',
            controllerAs: 'ctrl',
            link: function($scope, $element, attrs, ctrl) {

                $scope.card = {};
                $scope.loading = false;
                $scope.$on($scope.displayEvent, ctrl.resetCard);

                ctrl.setCard($scope.card);

                ctrl.setLoading = function(loading) {
                    $scope.loading = loading;
                };

                ctrl.fireDismissEvent = function() {
                    $scope.$broadcast($scope.dismissEvent);
                };
            }
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit.card.update.directive.js
// module id = 490
// module chunks = 0